document.addEventListener('DOMContentLoaded', () => {
  initWishlist();
});

// Initialize Wishlist logic
function initWishlist() {
  let wishlist = getWishlist();
  
  // 1. Show all hidden wishlist buttons and header links
  revealWishlistElements();

  // 2. Synchronize all wishlist button icon states on load
  syncAllWishlistButtons(wishlist);

  // 3. Attach click event listeners globally
  document.addEventListener('click', handleWishlistClick);

  // 4. Update header count badge
  updateHeaderBadge(wishlist.length);

  // 5. Handle Wishlist Page rendering if active
  if (document.querySelector('.wishlist-grid-wrapper')) {
    renderWishlistPage(wishlist);
  }
}

// Get wishlist array from localStorage
function getWishlist() {
  try {
    const list = localStorage.getItem('wishlist_products');
    return list ? JSON.parse(list) : [];
  } catch (e) {
    console.error('Failed to parse wishlist from localStorage', e);
    return [];
  }
}

// Save wishlist array to localStorage
function saveWishlist(wishlist) {
  try {
    localStorage.setItem('wishlist_products', JSON.stringify(wishlist));
  } catch (e) {
    console.error('Failed to save wishlist to localStorage', e);
  }
}

// Reveal all pre-existing hidden wishlist elements
function revealWishlistElements() {
  document.querySelectorAll('.wishlist-header, .wishlist-productpage, .wishlist-productcard').forEach(el => {
    el.classList.remove('hidden');
    // Ensure display isn't none by overriding custom CSS if any
    el.style.setProperty('display', '', 'important');
  });
}

// Update all heart icons across the site based on the current wishlist
function syncAllWishlistButtons(wishlist) {
  document.querySelectorAll('.wishlist-productcard, .wishlist-productpage a').forEach(btn => {
    let handle = btn.getAttribute('data-product-handle');
    
    // Failsafe 1: Parse handle from nearby card links if attribute is missing
    if (!handle) {
      const card = btn.closest('.product-card') || btn.closest('[data-product-id]') || btn.closest('li') || btn.closest('div');
      if (card) {
        const link = card.querySelector('a[href*="/products/"]');
        if (link) {
          const href = link.getAttribute('href');
          const match = href.match(/\/products\/([a-zA-Z0-9\-_]+)/);
          if (match) {
            handle = match[1];
            btn.setAttribute('data-product-handle', handle);
          }
        }
      }
    }

    // Failsafe 2: Parse handle from window location pathname if on product detail page
    if (!handle && window.location.pathname.includes('/products/')) {
      const match = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-_]+)/);
      if (match) {
        handle = match[1];
        btn.setAttribute('data-product-handle', handle);
      }
    }

    if (!handle) return;

    const icon = btn.querySelector('i');
    if (!icon) return;

    if (wishlist.includes(handle)) {
      icon.classList.remove('icon-heart-outline');
      icon.classList.add('icon-heart');
      btn.classList.add('is-active');
    } else {
      icon.classList.remove('icon-heart');
      icon.classList.add('icon-heart-outline');
      btn.classList.remove('is-active');
    }
  });
}

// Global click event listener for wishlist buttons
function handleWishlistClick(e) {
  // Find any clicked wishlist button
  const btn = e.target.closest('.wishlist-productcard') || e.target.closest('.wishlist-productpage a');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  let handle = btn.getAttribute('data-product-handle');
  
  // Failsafe 1: Parse handle from card link if attribute is missing
  if (!handle) {
    const card = btn.closest('.product-card') || btn.closest('[data-product-id]') || btn.closest('li') || btn.closest('div');
    if (card) {
      const link = card.querySelector('a[href*="/products/"]');
      if (link) {
        const href = link.getAttribute('href');
        const match = href.match(/\/products\/([a-zA-Z0-9\-_]+)/);
        if (match) {
          handle = match[1];
          btn.setAttribute('data-product-handle', handle);
        }
      }
    }
  }

  // Failsafe 2: Parse handle from window location pathname if on product page
  if (!handle && window.location.pathname.includes('/products/')) {
    const match = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-_]+)/);
    if (match) {
      handle = match[1];
      btn.setAttribute('data-product-handle', handle);
    }
  }

  if (!handle) return;

  let wishlist = getWishlist();
  const isAdded = !wishlist.includes(handle);

  if (isAdded) {
    wishlist.push(handle);
    showToast('Product added to your wishlist!', true);
  } else {
    wishlist = wishlist.filter(h => h !== handle);
    showToast('Product removed from wishlist.', false);
  }

  saveWishlist(wishlist);
  syncAllWishlistButtons(wishlist);
  updateHeaderBadge(wishlist.length);

  // If on wishlist page and item was removed, handle fading out
  if (document.querySelector('.wishlist-grid-wrapper')) {
    const pageItem = document.querySelector(`.wishlist-grid li:has([data-product-handle="${handle}"]), .wishlist-grid li:has([data-handle="${handle}"])`);
    const targetItem = pageItem || btn.closest('li');
    if (targetItem) {
      targetItem.classList.add('fade-out');
      setTimeout(() => {
        targetItem.remove();
        if (wishlist.length === 0) {
          showEmptyWishlist();
        }
      }, 300);
    }
  }
}

// Update header wishlist count badge
function updateHeaderBadge(count) {
  const headerLinks = document.querySelectorAll('.wishlist-header a');
  headerLinks.forEach(link => {
    let badge = link.querySelector('.wishlist-count-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'wishlist-count-badge plain';
      link.appendChild(badge);
    }
    badge.textContent = count;
    if (count > 0) {
      badge.style.display = 'inline-block';
    } else {
      badge.style.display = 'none';
    }
  });
}

// Show premium Toast Notification
function showToast(message, isAdded) {
  let container = document.getElementById('wishlist-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'wishlist-toast-container';
    document.body.appendChild(container);
  }
  const toast = document.createElement('div');
  toast.className = 'wishlist-toast';
  toast.innerHTML = `
    <span class="wishlist-toast-icon"><i class="icon-heart"></i></span>
    <span class="wishlist-toast-msg">${message}</span>
    ${isAdded ? '<a href="/pages/wishlist" class="wishlist-toast-link">View Wishlist</a>' : ''}
  `;
  container.appendChild(toast);
  setTimeout(() => {
    toast.classList.add('show');
  }, 50);
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 400);
  }, 3500);
}

// Show the empty wishlist message state
function showEmptyWishlist() {
  const wrapper = document.querySelector('.wishlist-grid-wrapper');
  if (!wrapper) return;

  const loading = wrapper.querySelector('.wishlist-grid-loading');
  const grid = wrapper.querySelector('.wishlist-grid');
  const empty = wrapper.querySelector('.wishlist-empty');

  if (loading) loading.style.display = 'none';
  if (grid) grid.style.display = 'none';
  if (empty) empty.style.display = 'block';
}

// Render product cards inside grid on the dedicated page
function renderWishlistPage(wishlist) {
  const wrapper = document.querySelector('.wishlist-grid-wrapper');
  if (!wrapper) return;

  const loading = wrapper.querySelector('.wishlist-grid-loading');
  const grid = wrapper.querySelector('.wishlist-grid');
  const empty = wrapper.querySelector('.wishlist-empty');

  if (wishlist.length === 0) {
    showEmptyWishlist();
    return;
  }

  // Create placeholders in order to keep products in their added order
  grid.innerHTML = '';
  grid.style.display = ''; // Inherit native theme's responsive grid/tile styles
  
  const placeholders = wishlist.map(handle => {
    const li = document.createElement('li');
    li.className = 'wishlist-placeholder-item';
    li.setAttribute('data-handle', handle);
    li.innerHTML = `
      <div class="wishlist-card-skeleton">
        <div class="wishlist-skeleton-media"></div>
        <div class="wishlist-skeleton-info">
          <div class="wishlist-skeleton-line"></div>
          <div class="wishlist-skeleton-line short"></div>
        </div>
      </div>
    `;
    grid.appendChild(li);
    return li;
  });

  if (loading) loading.style.display = 'none';

  let loadedCount = 0;

  wishlist.forEach((handle, index) => {
    fetch(`/products/${handle}?section_id=product-item`)
      .then(res => {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const sectionContent = doc.getElementById('shopify-section-product-item');
        
        if (sectionContent && sectionContent.innerHTML.trim().length > 0) {
          const placeholderLi = placeholders[index];
          const cardEl = sectionContent.querySelector('.product-card') || sectionContent.firstElementChild;
          
          if (cardEl) {
            cardEl.setAttribute('data-handle', handle);
            placeholderLi.replaceWith(cardEl);
            
            const btn = cardEl.querySelector('.wishlist-productcard');
            if (btn) {
              btn.classList.remove('hidden');
              btn.style.setProperty('display', '', 'important');
              const icon = btn.querySelector('i');
              if (icon) {
                icon.classList.remove('icon-heart-outline');
                icon.classList.add('icon-heart');
              }
            }
          } else {
            placeholderLi.remove();
          }
        } else {
          placeholders[index].remove();
        }
      })
      .catch(err => {
        console.error(`Failed to load product card for ${handle}:`, err);
        placeholders[index].remove();
      })
      .finally(() => {
        loadedCount++;
        // If all fetches are done and grid is completely empty (e.g. deleted or deactivated products)
        if (loadedCount === wishlist.length) {
          const activeItems = grid.querySelectorAll('li:not(.wishlist-placeholder-item)');
          if (activeItems.length === 0) {
            showEmptyWishlist();
          }
        }
      });
  });
}
